module.exports = __webpack_public_path__ + "static/media/curology-bottles-over-website.ce154fe9.jpg";